import React from 'react';

import styled from '@emotion/styled';
import { mq, dot, grayBorder, breakP } from '../../_style';
import items from '../../assets/data/products.json';
import BtnGroup, { BtnData } from './btnGroup';
import Image from '../atoms/image';
import LabelGroup from '../molecules/labelGroup';
import BuyBtn from '../atoms/buyBtn';
import Btn from '../atoms/btn';
import Link from '../atoms/link';
import ProductItem from '../molecules/productItem';
import { animateScroll as scroll } from 'react-scroll';

const transitionSecond = 200;

const Container = styled.div`
  position: relative;
  z-index: 5000;
  ${mq.sp} {
    margin-bottom: 60px;
  }
`;
const Ui = styled.div`
  margin: 120px 0 60px;
  ${mq.sp} {
    margin: 45px 0 15px;
  }
`;
const List = styled.div`
  ${mq.pc} {
    margin: 0 auto;
    max-width: 960px;
    padding: 30px 52px 0;
    padding-bottom: 86px;
    box-sizing: content-box;
  }
  ${mq.sp} {
    padding: 30px 20px 0;
  }
`;
const ListHead = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${grayBorder};
  font-size: 14px;
  line-height: 1;
  padding-bottom: 30px;
`;
const ListHeadInner = styled.div``;

const ListBody = styled.div``;
const CategoryName = styled.span`
  background-position: right;
  display: inline-block;
  margin-right: 20px;
  ${dot('y', 1, 2, '#d9d9d9')}
  padding-right: 20px;
`;
const Amount = styled.span`
  display: inline-block;
`;
const Items = styled.ul`
  display: flex;
  flex-wrap: wrap;
  opacity: 1;
  transition: opacity ${transitionSecond}ms ease;
  .is-filtering & {
    opacity: 0;
  }
`;
export default class Filter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialItems: items,
      items: [],
      category: null,
      categoryName: null,
      amount: 0,
      activeAccordion: 0,
      headerHeight: 0,
    };
    this.buyBtnHandler = this.buyBtnHandler.bind(this);
  }

  componentDidMount() {
    this.param = this.getUrlVars(this.props.history.location.search);
    let firstCategoryName = '全て';
    BtnData.forEach(data => {
      data.forEach(item => {
        if (item.value === this.param) firstCategoryName = item.category;
      });
    });
    this.setState({
      items: this.state.initialItems,
      category: this.param,
      categoryName: firstCategoryName,
      amount: this.state.initialItems.length,
      headerHeight: window.innerWidth < breakP ? 0 : 63,
    });
    if (this.param) {
      const updateListItems = this.makeUpdateList(this.param);
      this.updateList(updateListItems);
    }
  }

  getUrlVars(params) {
    if (params === '') return null;
    const variables = params.split('?')[1].split('&');
    const obj = {};
    variables.forEach((v, i) => {
      const variable = v.split('=');
      obj[variable[0]] = variable[1];
    });
    return obj.category;
  }

  filterList = e => {
    const changeEvent = e;
    this.setState({
      category: changeEvent.target.value,
      categoryName: changeEvent.target.dataset.categoryname,
    });
    const updateListItems = this.makeUpdateList(changeEvent.target.value);
    this.updateList(updateListItems);
    history.pushState(null, null, `?category=${changeEvent.target.value}`);
  };

  makeUpdateList = value => {
    if (value === 'all') return this.state.initialItems;
    const filterdItems = [];
    this.state.initialItems.forEach(item => {
      if (item.category.indexOf(value) >= 0) {
        filterdItems.push(item);
      }
    });
    if (
      value === 'periodontaldisease' ||
      value === 'whitening' ||
      value === 'sterilize'
    ) {
      const weightOption = `${value}Weight`;
      filterdItems.sort((a, b) => {
        const weightA = a[weightOption];
        const weightB = b[weightOption];

        let comparison = 0;
        if (weightA > weightB) {
          comparison = 1;
        } else if (weightA < weightB) {
          comparison = -1;
        }
        return comparison;
      });
    }
    return filterdItems;
  };

  updateList(items) {
    this.setState({ amount: items.length });
    document.body.classList.add('is-filtering');
    setTimeout(() => {
      scroll.scrollTo(
        this.listEle.getBoundingClientRect().top +
          window.pageYOffset -
          this.state.headerHeight,
        { duration: 800 }
      );
      this.setState({ items: items });
      document.body.classList.remove('is-filtering');
    }, transitionSecond);
  }

  buyBtnHandler(id) {
    this.setState({ activeAccordion: id });
  }

  render() {
    return (
      <Container>
        <Ui>
          <BtnGroup
            fun={this.filterList}
            query={this.state.category}
            isRadio
          ></BtnGroup>
        </Ui>
        <List id="list" ref={list => (this.listEle = list)}>
          <ListHead>
            <ListHeadInner>
              <CategoryName>{this.state.categoryName}</CategoryName>
              <Amount>{this.state.amount}件</Amount>
            </ListHeadInner>
          </ListHead>
          <ListBody>
            <Items>
              {this.state.items.map((item, index) => {
                return (
                  <ProductItem key={index} isNew={item.isNew}>
                    <div>
                      <Link to={item.detailUrl}>
                        <Image filename={item.img} alt={item.name}></Image>
                      </Link>
                      <h6>{item.name}</h6>
                      <LabelGroup labels={item.label}></LabelGroup>
                      <p>{item.description}</p>
                    </div>
                    <div>
                      <Btn to={item.detailUrl}>詳細はこちら</Btn>
                      <BuyBtn
                        amazonUrl={item.amazonUrl}
                        lohacoUrl={item.lohacoUrl}
                        rakutenUrl={item.rakutenUrl}
                        sendState={this.buyBtnHandler}
                        openedAccordion={this.state.activeAccordion}
                        activeKey={index}
                        isDisable={
                          item.amazonUrl === '' &&
                          item.lohacoUrl === '' &&
                          item.rakutenUrl === ''
                        }
                      >
                        ご購入はこちら
                      </BuyBtn>
                    </div>
                  </ProductItem>
                );
              })}
            </Items>
          </ListBody>
        </List>
      </Container>
    );
  }
}
